export const DISK_SPACE_LOW_EVENT = 'RECORDING_DISK_SPACE_LOW';

/**
 * Payload of the Rust low-disk-space warning event. Re-emitted on low readings
 * so a renderer recreated during a live native capture can recover the current
 * state; the accept filter below deduplicates it within each renderer.
 */
export type DiskSpaceLowPayload = {
  sessionId: string;
  availableBytes: number;
  thresholdBytes: number;
  errorCode: string;
  ts: number;
};

/**
 * Accept filter for {@link DISK_SPACE_LOW_EVENT}, mirroring the WAV-writer
 * health filtering:
 * - only the active capture's session is accepted (dictation's empty session
 *   id is rejected, as is any stale event from a previous session);
 * - the first accepted warning wins for a session (Rust periodically replays
 *   low state for WebView recovery, and device-change restarts re-arm it, so
 *   the FE dedupes per session);
 * - events stamped before `acceptedAfterTs` are dropped as stale.
 */
export function shouldAcceptDiskSpaceLow(
  payload: DiskSpaceLowPayload,
  activeSessionId: string | null,
  currentWarning?: DiskSpaceLowPayload,
  acceptedAfterTs = 0
): boolean {
  if (!payload.sessionId || payload.sessionId !== activeSessionId) return false;
  if (currentWarning?.sessionId === activeSessionId) return false;
  if (payload.ts < acceptedAfterTs) return false;
  return true;
}
